<template>
    <div>
        <div class="q-mt-xs container">
            <div class="row justify-between q-mb-md">
                <div class="col">
                    <h3 v-html="title"></h3>
                </div>
                <div class="col-auto" v-if="uri">
                    <router-link :to="uri" class="small">{{ $T('see all') }}</router-link>
                </div>
            </div>
        </div>

        <div v-if="$breakpoints.isGreaterThan('sm')" class="q-mb-xl container">
            <div class="row gutter-sm">
                <v-card v-for="(item, i) in items" :key="i" :layout="layout" :item="item" :is-video="isVideo"/>
            </div>
        </div>

        <div v-else class="horizontal-lock carousel q-mb-md">
            <v-carousel :layout="layout" :items="items" :is-video="isVideo"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'VRow',

        props: {
            title: String,
            layout: {
                type: String,
                required: true
            },
            uri: String,
            items: {
                type: Array,
                required: true
            },
            isVideo: Boolean
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/front/Row.vue